<template>
  <div>
    <div class="sy_nav">
      <ul>
        <li><router-link :to="{ path: '/'}" >首页</router-link></li>
        <li><router-link :to="{ path: '/about'}" target="_blank">关于学会</router-link></li>
        <li><router-link :to="{ path: '/continuingMedicalEducation'}" >继续教育</router-link></li>
        <li><router-link :to="{ path: '/learningActivities'}" >学会活动</router-link></li>
        <li><router-link :to="{ path: '/medicalAccidentIdentification'}" >医疗事故鉴定</router-link></li>
        <li><router-link :to="{ path: '/RegularExamination'}" >医师定期考核</router-link></li>
        <li><router-link :to="{ path: '/hotNews'}" >新闻热点</router-link></li>
        <li><router-link :to="{ path: '/downLoad'}" >下载专区</router-link></li>
        <li><router-link :to="{ path: '/queryCredit'}" >学分查询</router-link></li>
      </ul>
      <div class="sy_search">
        <input type="text" maxlength="10" name="" autocomplete="off" placeholder="" v-model="keyword" />
        <button @click="search" style="cursor:pointer"><img src="../assets/img/search.gif" width="49" height="21" /></button>
      </div>
    </div>
    <div class="sy_nav_bottom"></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        keyword:''
      }
    },
    methods: {
      search() {
        this.$router.push({ path: '/medicalSearch', query: { keyword:  this.keyword}})
      },

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue